<div class="content">
  <!-- Filters -->
  <section class="left-bar">
    @if (initialized && reports.length) {
      <form [formGroup]="inputForm">
        <div class="filters">
          <div>
            <button mat-stroked-button color="primary" (click)="onSubmit(inputForm)">
              Fetch report
            </button>
          </div>
          <!-- Reports section -->
          <section class="facet">
            <div class="facet-body">
              <mat-form-field>
                <mat-label>Select report</mat-label>
                <mat-select formControlName="reportId" [errorStateMatcher]="matcher">
                  @for (report of reports; track report) {
                    <mat-option [value]="report.id">
                      {{report.name}}
                    </mat-option>
                  }
                </mat-select>
                @if (inputForm.controls.reportId.hasError('required')) {
                  <mat-error>
                    This field is <strong>required</strong>
                  </mat-error>
                }
                @if (inputForm.controls.reportId.hasError('error')) {
                  <mat-error>
                    {{inputForm.controls.scope_id.errors.error}}
                  </mat-error>
                }
              </mat-form-field>
            </div>
          </section>
          <!-- /Reports section -->
          <!-- Site selector -->
          <section class="facet">
            <div class="facet-title">Sites</div>
            <div class="facet-body">
              <mat-radio-group matInput aria-label="Select site" formControlName="siteId" class="facet-radio"
                [errorStateMatcher]="matcher">
                @for (site of sites; track site) {
                  <div>
                    <div class="columns">
                      <mat-radio-button [value]="site.id">
                        <div class="mat-body-2">{{ site.name }}</div>
                      </mat-radio-button>
                    </div>
                  </div>
                }
              </mat-radio-group>
              @if (inputForm.controls.siteId.hasError('required')) {
                <mat-error>
                  This field is <strong>required</strong>
                </mat-error>
              }
              @if (inputForm.controls.siteId.hasError('error')) {
                <mat-error>
                  {{inputForm.controls.scope_id.errors.error}}
                </mat-error>
              }
            </div>
          </section>
          <!-- /Site selector -->
          <!-- Dates -->
          <section class="facet">
            <div class="facet-title">Date</div>
            <div class="facet-body">
              <mat-form-field>
                <input matInput [matDatepicker]="reportDatePicker" formControlName="date" [errorStateMatcher]="matcher"
                  autocomplete="off" />
                <mat-datepicker-toggle matSuffix [for]="reportDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #reportDatePicker [calendarHeaderComponent]="calendarHeader"></mat-datepicker>
                @if (inputForm.controls.date.hasError('required')) {
                  <mat-error>
                    This field is <strong>required</strong>
                  </mat-error>
                }
                @if (inputForm.controls.date.hasError('error')) {
                  <mat-error>
                    {{ inputForm.controls.date.errors.error }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
          </section>
          <!-- Dates -->
        </div>
      </form>
    }
    <!-- Filters -->
  </section>

  <!-- Report Preview -->
  <section class="content-body">
    @if (loading) {
      <mat-spinner class="spinner" color="accent" mode="indeterminate"></mat-spinner>
    }

    @if (initialized && !reports.length) {
      <div class="mat-body-strong" style="text-align: center;">
        Found no reports for this project
      </div>
    }

    <div [hidden]="!reportHtml" class="report-preview">
      <div class="mat-subtitle-1 row" style="align-items: center">
        @if (downloading) {
          <mat-spinner strokeWidth="3" diameter="32" mode="indeterminate" color="accent">
          </mat-spinner>
        }
        @if (!downloading) {
          <button mat-icon-button title="Download pdf" (click)="downloadReport()">
            <mat-icon>download</mat-icon>
          </button>
        }
      </div>
      <div class="preview-container">
        <iframe #iframe class="preview-frame"></iframe>
      </div>
    </div>
  </section>
  <!-- Report Preview -->
</div>